import { ResponsivePie } from "@nivo/pie";
import React, { Component } from "react";
import StaticClass from "../../utils/staticClass"
const theme = {
  labels: {
    text: {
      fontSize: "12px",
    },
  },
};
const NivoPie = ({ data, type, legend }) => {
  return (
    <ResponsivePie
      theme={theme}
      data={data}
      margin={{ top: 40, right: 90, bottom: 40, left: 10 }}
      startAngle={-90}
      sortByValue={true}
      colors={function (e) {
        return e.data.color;
      }}
      borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
      enableRadialLabels={false}
      radialLabel="id"
      sliceLabel={function (e) {
        return `${StaticClass.formatPrice(e.value)}%`;
      }}
      sliceLabelsSkipAngle={12}
      sliceLabelsTextColor="#ffffff"
      tooltip={function (e) {
        switch (type) {
          case "QHCT_QuyHoach":
            return (
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "5px",
                  padding: "5px",
                  borderColor: "#ddd",
                  boxShadow: "0px 2px 24px rgba(114, 132, 155, 0.2)",
                }}
              >
                <div style = {{display: "flex", justifyContent: "center", fontWeight: "500"}}>{e.datum.data.label}</div>
                <div>Diện tích: {e.datum.data.DienTich} (ha)</div>
                <div>Tỷ lệ: {e.datum.data.value}%</div>
              </div>
            );

          case "QHCT_Dat":
            return (
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "5px",
                  padding: "5px",
                  borderColor: "#ddd",
                  boxShadow: "0px 2px 24px rgba(114, 132, 155, 0.2)",
                }}
              >
                <div style = {{fontWeight: 700, paddingLeft: "5px", marginBottom: "5px"}}>
                  {e.datum.data.label}: {e.datum.data.value}%
                </div>

                <div style={{ paddingLeft: "5px" }}>
                  {
                    e.datum.data.children.map(e=>(
                      <div style = {{display: "flex"}}>
                        <div style = {{marginRight: "5px"}}>{e.LoaiDat}:</div>
                        <div>{e.TyLe}%</div>
                      </div>
                    ))
                  }
                </div>
              </div>
            );

          case "QHC":
            return (
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "5px",
                  padding: "5px",
                  borderColor: "#ddd",
                  boxShadow: "0px 2px 24px rgba(114, 132, 155, 0.2)",
                }}
              >
                <div>{e.datum.data.label}</div>
                <div>Diện tích: {e.datum.data.DienTich} (ha)</div>
                <div>Tỷ lệ: {e.datum.data.value}%</div>
              </div>
            );

          case "QHPK":
            return (
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "5px",
                  padding: "5px",
                  borderColor: "#ddd",
                  boxShadow: "0px 2px 24px rgba(114, 132, 155, 0.2)",
                  zIndex: "100",
                }}
              >
                {/* <div>{e.datum.data.label}: {e.datum.data.value}%</div> */}
                {e.datum.data.listHover.map((e, i) => (
                  <div style={{ display: "flex" }} key={i}>
                    <div>{e.LoaiDat}: &nbsp;</div>
                    <div> {e.DienTich} (ha)</div>
                  </div>
                ))}
              </div>
            );
          default:
            return null;
        }
      }}
      legends={[
        {
          anchor: "right",
          direction: "column",
          justify: false,
          translateX: type === "QHPK" || type === "QHC" ? 60 : 130,
          translateY: 0,
          itemWidth: 200,
          itemHeight: 20,
          itemsSpacing: 0,
          symbolSize: 12,
          itemDirection: "left-to-right",
        },
      ]}
    ></ResponsivePie>
  );
};

export default NivoPie;
